import { updateProjectShortCut } from '../../actions/userDashboardAction';
import Tooltip from "react-simple-tooltip"
import { Link } from 'react-router-dom';

const ShortcutsDashbord = (props) => {

    const pinToShortCut = (shortcut) => {
        let projectData = {
            project_id: shortcut.id,
            is_in_shortcuts: !shortcut.is_in_shortcuts
        }
        return updateProjectShortCut(projectData)
            .then(props.refreshProject)
    }
    return (
        <>
            <div className="col-lg-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">My Shortcuts</h2>
                        {/* <a className="header-dropdown dropdown dropdown-animated scale-left text-white"><i className="fa fa-pencil mr-2"></i>Edit Shortcuts</a> */}
                    </div>
                    <div className="body text-center card-body-shadow">
                        <div className="row clearfix">
                            {props.shortcuts && props.shortcuts.map((shortcut, index) => (
                                <div key={index} className="col-lg-4 col-md-8 col-sm-12 mt-3">
                                    <div className="icon-menu">
                                        <div className="card p-3 rounded-xl">
                                            <img width={70} height={70} className="rounded-circle" alt="75x75" src="https://p1.hiclipart.com/preview/100/806/378/yosemite-icons-shortcuts-png-icon.jpg"/><br></br>
                                            <Link to={`/schedule-details/${shortcut.id}`} className="mt-2 btn button">{shortcut.title}</Link>
                                        </div>
                                        <span className="delete-icon" onClick={() => pinToShortCut(shortcut)}>
                                            <Tooltip  background="#fa7a13" color="#fff" border="0" fontSize="8" fontFamily="sans-serif" placement="bottom" radius={5} zIndex={1} content="Remove from shortcut">
                                                <i className="fa fa-thumb-tack"></i>
                                            </Tooltip>
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ShortcutsDashbord;